import { render } from "./Feeds.vue?vue&type=template&id=3fd6c2fd"
import script from "./Feeds.vue?vue&type=script&lang=ts"
export * from "./Feeds.vue?vue&type=script&lang=ts"
script.render = render

export default script